import {
    Modal,
    ModalBody,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
} from '@/components/v4';
import { Button } from '@chakra-ui/react';

export default function DeleteAdminModal({
    isOpen,
    onClose,
    deleteOnClick,
    finalRef,
}) {
    return (
        <Modal
            finalFocusRef={finalRef}
            isOpen={isOpen}
            onClose={onClose}
            isCentered
            size="xl">
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>Delete user</ModalHeader>
                <ModalBody>
                    Are you sure you would like to delete this user?
                </ModalBody>

                <ModalFooter>
                    <Button
                        variant="ghost"
                        bg="transparent"
                        mr={3}
                        colorScheme="black"
                        onClick={onClose}>
                        Close
                    </Button>
                    <Button
                        variant="solid"
                        colorScheme="red"
                        onClick={deleteOnClick}>
                        Delete
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
}
